import React from 'react';
import { useLocation } from '@reach/router';
import { Box } from '@hover/blueprint';
import { IJob } from '../../../interfaces/IJob';
import OpenRole from './OpenRole';

interface Props {
  openRoles: IJob[];
}

const List: React.FC<Props> = ({ openRoles }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  return (
    <Box w="100%" flexDir="column" alignItems="flex-start">
      {openRoles.map(role => (
        <OpenRole
          ghSource={searchParams.get('gh_src')}
          openRole={role}
          key={role.id}
        />
      ))}
    </Box>
  );
};

export default List;
